window.dataLayer = window.dataLayer || [];

export function pushDL(eventName, payload) {
  const data = Object.assign({ event: eventName }, payload || {});
  window.dataLayer.push(data);
  if (window.DL_DEBUG) console.log('[dataLayer]', data);
}
